<template>
    <div>
        <div id="metamask" v-if="initIsShowPopup && !isShowPopupOkPopup">
            <div class="metamask_box">
                <img src="../assets/images/icon_close.svg" alt="close" class="close" @click="closePopup" />
                <h1>Kaikas</h1>
                <img src="../assets/images/Kaikas-logo-blanc.svg" class="fox" />
                <p>Kaikas 지갑 연결이 필요합니다</p>
                <p>ATT 코인으로 충전을 하기 위해서 Kaikas 지갑을 연결하거나, 새 지갑 생성이 필요합니다.</p>
                <div class="contact_button" @click="connectWallet">지갑 연결하기</div>
                <div class="later_button" @click="closePopup">다음에 하기</div>
            </div>
        </div>
        <VueKaikas @onComplete="onComplete" :initLoadKaikas="$store.state.isEnableKaikas" :initIsMainNetForce="initIsMainNetForce" />
        <PopupOK :initIsShowPopup="isShowPopupOkPopup" :initPopupOkMessage="initPopupOkMessage" @close="close('PopupOk')" />
    </div>
</template>

<script>
import VueKaikas from '@/components/VueKaikas.vue'
import PopupOK from '@/components/PopupOK.vue'
import Caver from "caver-js";

export default {
    name: 'Kaikas',
    components: {
        VueKaikas,
        PopupOK,
    },
    
    data() {
        return {
            tokenInterval: null,

            isShowPopupOkPopup: false,
            initPopupOkMessage: '',
            PopupOkCallbakPage: '',    // 확인 팝업에서 확인 버튼 눌렀을때 이동할 페이지
        }
    },
    props: {
        initIsMainNetForce: {   //메인넷 고정 여부
            type: Boolean,
            default: false
        },
        initIsShowPopup: {      //지갑 연결 팝업 표시 여부
            type: Boolean,
            default: false
        },
        initRunInterval:{       //Token Info 타이머 실행 여부
            type: Boolean,
            default: false
        }
    },
    async created() {
        var that = this;
        await this.mixinLoginCheck();
        await this.checkKaikas();

        if(this.$store.state.isEnableKaikas && this.$store.state.erc20Address !== null && this.$store.state.erc20Address !== '' && this.$store.state.account !== ''){
            that.getTokenInfo();
        }

        if(this.initRunInterval){
            this.$store.state.tokenInfoTimerCount = 10;

            this.tokenInterval = setInterval(() => {
                if(that.$store.state.tokenInfoTimerCount <= 0){
                    if(that.$store.state.isEnableKaikas && that.$store.state.erc20Address !== null && that.$store.state.erc20Address !== '' && that.$store.state.account !== ''){
                        that.getTokenInfo();
                    }
                    that.$store.state.tokenInfoTimerCount = 10;
                }else{
                    that.$store.state.tokenInfoTimerCount--;
                }
            }, 1000);
        }
    },
    mounted(){
    },
    beforeDestroy() {
        if(this.tokenInterval){
            clearInterval(this.tokenInterval);
        }
	},
    methods: {
        closePopup(){
            this.$emit('close');
        },
        async checkKaikas(){  //메타 마스크, 카이카스 체크
			var that = this;

            var klaytn = await window.klaytn;
            if(typeof klaytn !== 'undefined'){
                setTimeout(async function(){
                    if(that.$store.state.loginCheck && that.$store.state.erc20Address !== '' && that.$store.state.erc20Address !== null){
                        await klaytn.enable().then(accounts => {
                            that.$store.state.account = accounts[0];
                            that.$store.state.isEnableKaikas = true;
                        });
                    }
                }, 500)
            }
        },
        async connectWallet(){
            var that = this;
            if(this.$store.state.isEnableKaikas){
                this.signature();
            }
            else{
                var klaytn = await window.klaytn;
                if(typeof klaytn !== 'undefined'){
                    await klaytn.enable().then(accounts => {
                        that.$store.state.account = accounts[0];
                        that.$store.state.isEnableKaikas = true;
                        setTimeout(()=>{that.signature()}, 1000);
                    });
                }
                else{
                    this.initPopupOkMessage = 'Kaikas 미설치 또는 잠금 상태입니다.<br/>설치된 상태면 실행하여 로그인 해주세요.<br/><a href="https://chrome.google.com/webstore/detail/kaikas/jblndlipeogpafnldhgmapagcccfchpi?hl=ko" target="_blank" class="metamask_download">Kaikas 설치하기</a>';
                    this.isShowPopupOkPopup = true;
                }
            }
        },
        onComplete(data){   //메타 마스크, 카이카스 리턴 대기
            if(data.type === "CHANGED_ACCOUNT"){
                this.initPopupOkMessage = 'Kaikas 지갑이 변경되었습니다.';
                this.PopupOkCallbakPage = 'reload'
                this.isShowPopupOkPopup = true;
				// this.$router.push('/' + this.currentPageName);
				// this.disconnect();
				// this.connectMetamask();
			}
            else if(data.type === "LOCKED_WALLET"){
                this.initPopupOkMessage = 'Kaikas가 잠금 설정 중입니다.';
                this.isShowPopupOkPopup = true;
				this.disconnect();
			}
            else if(data.type === "EMPTY_WALLET_ACCOUNT"){
                this.initPopupOkMessage = 'Kaikas에 연결된 지갑 없습니다.';
                this.isShowPopupOkPopup = true;
				this.disconnect();
			}
            else if(data.type === "NOT_INSTALL"){
                this.initPopupOkMessage = 'Kaikas가 설치되지 않았습니다.';
                this.isShowPopupOkPopup = true;
                this.disconnect();
            }
            else if(data.type === 'LOAD_MATAMASK_WALLET_ERROR'){
                this.initPopupOkMessage = 'Kaikas를 정상적으로 로드하지 못했습니다.';
                this.isShowPopupOkPopup = true;
                this.disconnect();
            }
            else if(data.type === 'MAIN_NET_FORCE'){
                this.initPopupOkMessage = 'Kaikas 네트워크를 메인넷으로 변경해 주세요.';
                this.PopupOkCallbakPage = 'reload'
                this.isShowPopupOkPopup = true;
            }
            // else if(data.type === 'TEST_NET'){
            //     this.initPopupOkMessage = 'Kaikas 네트워크가 메인넷이 아닙니다.';
            //     this.isShowPopupOkPopup = true;
            //     this.disconnect();
            // }
            else if(data.type === 'MAIN_NET_FORCE'){
                this.initPopupOkMessage = 'Kaikas 네트워크가 변경되었습니다.';
                this.PopupOkCallbakPage = 'reload'
                this.isShowPopupOkPopup = true;
                // this.disconnect();
            }
        },
        disconnect(){   //메타 마스크, 카이카스 연결 끊기
            this.$store.commit("disconnectKaikas");
		},
        async getTokenInfo(){ // att 토큰 정보
            var param = 
            {
            }
            await this.$Axios.post(`${this.host}/tokenInfo`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.$store.state.tokenInfo = res.data.data;

                    if(this.$store.state.tokenInfo && this.$store.state.isEnableKaikas){
                        this.getTokenBalance(this.$store.state.tokenInfo.contractAddress, (balance)=>{
                            
                            if(balance !== null){
                                this.$store.state.attTokenBalance = Number(balance.toString());
                            }
                            else{
                                this.$store.state.attTokenBalance = 0;
                            }
                        });
                    }
                }
                else{
                    this.$store.state.tokenInfo = null;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async signature(){  //메타 마스크, 카이카스 사이닝
            var caver = new Caver(window.klaytn);
            var message = 'Artube Signature(' + Date.now().toString() + ')';

            return await caver.klay.sign(message, this.$store.state.account).then(signature => {
                var param = 
                {
                    address: this.$store.state.account,
                    message: message,
                    signature : signature,
                    sign: this.$store.state.sign,
                    ticket: this.$store.state.ticket,
                }
                // console.log(param)
                this.$Axios.post(`${this.host}/erc20/connect`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                    // console.log(res.data);
                    if (res.data.returnCode === 0) {
                        this.initPopupOkMessage = '지갑 연결이 완료 되었습니다.';
                        // this.PopupOkCallbakPage = 'wallet-connect'
                        this.PopupOkCallbakPage = 'reload'
                        this.isShowPopupOkPopup = true;
                    }
                    else if(res.data.returnCode === 914){
                        this.initPopupOkMessage = 'Kaikas 서명 오류 입니다.';
                        this.isShowPopupOkPopup = true;   
                    }
                    else if(res.data.returnCode === 915){
                        this.initPopupOkMessage = '이미 다른 계정에서 사용중인 지갑 입니다.';
                        this.isShowPopupOkPopup = true;   
                    }
                    else if(res.data.returnCode === 916){
                        this.initPopupOkMessage = '기존 등록된 지갑만 연결할 수 있습니다.<br/> Kaikas 지갑을 확인해 주세요';
                        this.isShowPopupOkPopup = true;   
                    }
                    else{
                        this.initPopupOkMessage = '지갑 연결이 실패했습니다.<br/>'+ res.data.description;
                        this.isShowPopupOkPopup = true;
                        // alert("지갑 연결 실패\n" + res.data.description);
                    }
                    return true;
                })
                .catch((error) => {
                    console.log(error);
                    return false;
                });
            })
            .catch(err => {
                console.log(err);
                return false;
            })
        },
        async getTokenBalance(tokenAddress, callback) {
            //  const kip7 = new caver.kct.kip7('0x07aa7ae19b17579f7237ad72c616fecf4ccc787b');//cypress att contract
            //  const kip7 = new caver.kct.kip7('0xeab9a65eb0f098f822033192802b53ee159de5f0');//baobab att contract
            // tokenAddress = "0xeab9a65eb0f098f822033192802b53ee159de5f0";
            
            try{
                var caver = new Caver(window.klaytn);
                var objKip7 = await new caver.kct.kip7(tokenAddress);

                await objKip7.balanceOf(this.$store.state.account).then(balance => {
                    objKip7.decimals().then(decimals=>{
                        balance = balance.div(10**decimals);
                        callback(balance);
                    })
                });
            }
            catch(err){
                return;
            }
		},
        close(popupType){
            switch(popupType){
                case 'PopupOk':
                    if(this.PopupOkCallbakPage === 'wallet-connect'){
                        this.closePopup();
                    }
                    else if(this.PopupOkCallbakPage === 'reload'){
                        location.reload();
                    }
                    else if(this.PopupOkCallbakPage !== ''){
                        this.$router.push(this.PopupOkCallbakPage);
                    }
                    this.isShowPopupOkPopup = false;
                    this.PopupOkCallbakPage = '';
                    break;
            }
        },
    }
}
</script>